import { sortObjectArray } from '../../utils';
import { SESSION_WORK_MILESTONES, SESSION_WORK_VALUE_KEY } from './constants';

export const formatMilestoneLabel = (threshold) => {
  const value = Number(threshold);
  if (!Number.isFinite(value) || value <= 0) {
    return '';
  }
  if (value >= 1000 && value % 1000 === 0) {
    return `${value / 1000}K`;
  }
  return String(value);
};

export const formatMilestoneSlug = (threshold) => formatMilestoneLabel(threshold).toLowerCase();

export const parseMilestoneParam = (param) => {
  if (param == null || param === '') {
    return null;
  }

  const raw = String(param).trim().toLowerCase();
  const kMatch = raw.match(/^(\d+(?:\.\d+)?)k$/);
  if (kMatch) {
    const parsed = Math.round(Number(kMatch[1]) * 1000);
    return SESSION_WORK_MILESTONES.includes(parsed) ? parsed : null;
  }

  const asNumber = Number(raw.replace(/,/g, ''));
  if (SESSION_WORK_MILESTONES.includes(asNumber)) {
    return asNumber;
  }

  return null;
};

export const getMilestoneRoute = (threshold) =>
  `/session-work/${formatMilestoneSlug(threshold)}`;

export const getSummaryMilestones = (payload) =>
  Array.isArray(payload?.milestones) ? payload.milestones : [];

export const getBoardEntries = (payload, key = 'entries') =>
  Array.isArray(payload?.[key]) ? payload[key] : [];

export const buildSessionWorkStandings = (entries, valueKey = SESSION_WORK_VALUE_KEY) => {
  const rows = (Array.isArray(entries) ? entries : [])
    .map((entry) => {
      const value = Number(entry?.[valueKey]);
      if (!Number.isFinite(value) || value <= 0) {
        return null;
      }

      const username = entry?.username || '';
      if (!username) {
        return null;
      }

      return {
        id: entry?.id || '',
        username,
        fullName: entry?.fullName || '',
        value,
        image: entry?.profilePicUrl || '',
        bestSessionId: entry?.bestSessionId || null,
        rank: Number(entry?.rank) || null,
      };
    })
    .filter(Boolean);

  const sorted = sortObjectArray(rows, 'value', 'desc');
  return sorted.map((row, index) => ({
    ...row,
    rank: index + 1,
  }));
};

export const getPodiumEntries = (standings, count = 3) =>
  (Array.isArray(standings) ? standings : []).slice(0, count);

export const resolveAvatarSrc = (image, userId) => {
  if (typeof image === 'string' && image.indexOf('https') === 0) {
    return image;
  }
  if (userId) {
    return `https://bbvr-user-profile-pics.s3.amazonaws.com/${userId}.png`;
  }
  return '';
};

export const findMilestoneSummary = (milestones, threshold) => {
  const list = Array.isArray(milestones) ? milestones : [];
  return list.find((item) => Number(item?.threshold) === Number(threshold)) || null;
};
